//import Vue from 'vue';
import { setCaretAtEnd } from '../utils/index';

const createCustomDirectives = (app, bootstrap) => {
  app.directive('auto-size', {
    created: function (el) {
      function resize() {
        var offset = el.offsetHeight - el.clientHeight;
        var height = el.scrollHeight + offset;
        if (parseInt(el.style.height) < height) setCaretAtEnd(el);
        el.style.height = 'auto';
        el.style.height = height + 'px';
        el.style.minHeight = '120px';
      }
      el.addEventListener('input', function () {
        //event.preventDefault();
        resize();
      });
      el.addEventListener('click', function (event) {
        event.preventDefault();
        resize();
      });
      resize();
    },
  });

  app.directive('b-tooltip', {
    created: function (el) {
      new bootstrap.Tooltip(el);
    },
  });

  app.directive('b-popover', {
    // binding, vnode, oldVnode
    created: function (el) {
      new bootstrap.Popover(el);
    },
  });
};

export default createCustomDirectives;
